import { CalculatorVersionType } from '@app/types'

export const CALCULATOR_VERSION: CalculatorVersionType = {
  TI30: {
    key: 'TI30',
    css: 'ti30mv-min.css',
    js: 'ti30mv-min.js',
    state: 'ti30mv.h84state',
    image: 'TI30XS_touch.svg',
  },
  TI108: {
    key: 'TI108',
    css: 'ti108-min.css',
    js: 'ti108-min.js',
    state: 'ti108.h84state',
    image: 'TI108_touch.svg',
  },
  TI34: {
    key: 'TI34',
    css: 'ti34mv-min.css',
    js: 'ti34mv-min.js',
    state: 'ti34mv.h84state',
    image: 'TI34MV.svg',
  },
  TI84: {
    key: 'TI84',
    css: 'ti84p-min.css',
    js: 'ti84p-min.js',
    state: 'No_Apps.h84statej',
    image: 'TI84SE_touch.svg',
  },
  TI84PCE: {
    key: 'TI84PCE',
    css: 'ti84pce-min.css',
    js: 'ELG-min.js',
    state: 'No_AppsCE.h84statej',
    image: 'TI84CE_touch.svg',
  },
  DESMOS: {
    key: '',
    css: '',
    js: '',
    state: '',
    image: '',
  },
}

export const CONTAINER_ID = 'exam-calculator'
